import { useEffect, useRef } from 'react';

import { selectIsOpenSidebar } from 'store/uiEffects/selectors';
import { setIsOpenSideBar } from 'store/uiEffects/actions';

import { useDispatch, useSelector } from 'hooks/store';

const useSidebar = () => {
    const dispatch = useDispatch();
    const isOpenSidebar = useSelector(selectIsOpenSidebar);

    const sidebarRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (isOpenSidebar && sidebarRef.current) {
            sidebarRef.current.scrollTop = 0;
        }

        document.body.style.overflow = isOpenSidebar ? 'hidden' : 'auto';
    }, [isOpenSidebar]);

    const open = () => {
        dispatch(setIsOpenSideBar(true));
    };

    const toggle = () => {
        dispatch(setIsOpenSideBar(!isOpenSidebar));
    };

    const close = () => {
        dispatch(setIsOpenSideBar(false));
    };

    return { open, close, toggle, isOpen: isOpenSidebar, sidebarRef };
};

export { useSidebar };
